 
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NotFoundPage from '../Components/NotFoundPage';
import Login from '../Pages/Authentication/Login';
import Signup from '../Pages/Authentication/Signup';
import ForgotPassword from '../Pages/Authentication/ForgotPassword';
import ResetPassword from '../Pages/Authentication/ResetPassword';
import AuthMiddleware from '../Components/AuthMiddleWare';
import { Helmet } from 'react-helmet';

const AuthRoutes = ({ setIsLoggedIn }) => (
  <>
    <Helmet>
      <title>DonorX</title>
    </Helmet>
    <Routes>
      <Route path="/login" element={<AuthMiddleware><Login setIsLoggedIn={setIsLoggedIn} /></AuthMiddleware>} />
      <Route path="/signup" element={<AuthMiddleware><Signup setIsLoggedIn={setIsLoggedIn} /></AuthMiddleware>} />
      <Route path="/forgotpassword" element={<AuthMiddleware><ForgotPassword setIsLoggedIn={setIsLoggedIn} /></AuthMiddleware>} />
      <Route path="/resetpassword" element={<AuthMiddleware><ResetPassword setIsLoggedIn={setIsLoggedIn} /></AuthMiddleware>} />
      <Route path="/*" element={<NotFoundPage />} />
    </Routes>
  </>
);

export default AuthRoutes;
